export default class DesktopBlogMenu {
    constructor(element) {
        this.selector = element;

        this.openDropdown();
        this.closeDropdown();
    }

    openDropdown() {
        const dropdowns = this.selector.querySelectorAll('[data-dropdown]');

        dropdowns.forEach((dropdown) => {
            const selector = dropdown.querySelector('[data-dropdown-selector]');
            const list = dropdown.querySelector('[data-dropdown-list]');

            selector.addEventListener('click', () => {
                list.classList.remove('hidden');
            });
        });
    }

    closeDropdown() {
        const dropdowns = this.selector.querySelectorAll('[data-dropdown]');

        window.addEventListener('click', (event) => {
            dropdowns.forEach((dropdown) => {
                const list = dropdown.querySelector('[data-dropdown-list]');
                const selector = dropdown.querySelector('[data-dropdown-selector]');

                if (!selector.contains(event.target) && !list.contains(event.target)) {
                    list.classList.add('hidden');
                }
            });
        });
    }
}